<template>
  <div class="shop-reviews">
    <template v-if="reviews.length > 0">
      <SfTable>
        <SfTableHeading>
          <SfTableHeader>Имя</SfTableHeader>
          <SfTableHeader>Телефон</SfTableHeader>
          <SfTableHeader>Почта</SfTableHeader>
          <SfTableHeader>Оценка</SfTableHeader>
          <SfTableHeader>Комментарий</SfTableHeader>
          <SfTableHeader>
            <SfButton class="sf-button--text">Действия</SfButton>
          </SfTableHeader>
        </SfTableHeading>
        <SfTableRow v-for="review in reviews" :key="review.id">
          <SfTableData>{{ review.name }}</SfTableData>
          <SfTableData>{{ review.phone }}</SfTableData>
          <SfTableData>{{ review.email }}</SfTableData>
          <SfTableData>
            <SfRating :max="5" :score="review.rating" icon="star" />
            </SfTableData>
          <SfTableData class="text-success">{{ review.comment }}</SfTableData>
          <SfTableData>
            <SfButton v-if="!review.delete_request" @click="removeReview(review.id)" class="sf-button--text">Запросить удаление</SfButton>
            <span v-else>Запрос на рассмотрении</span>
          </SfTableData>
        </SfTableRow>
      </SfTable>
    </template>
    <template v-else>
      Нет данных
    </template>
  </div>
</template>

<script>
import apiRequest from '../../shared/apiRequest'

import { SfTable, SfButton, SfRating } from '@storefront-ui/vue'

export default {
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    SfTable, SfButton, SfRating
  },
  data() {
    return {
      reviews: []
    }
  },

  mounted() {
    this.getReviews()
  },
  methods: {
    getReviews() {
      apiRequest.get(`/users/${this.account.id}/reviews`)
        .then(({ data }) => {
          this.reviews = data
        })
    },

    removeReview(id) {
      apiRequest.delete(`/reviews/${id}`)
        .then(() => {
          alert("Запрос отправлен!")
          this.getReviews()
        })
    }
  }
}
</script>

<style>

</style>